import React, { Component } from 'react';
import MaxWidthLayout from '../../../templates/MaxWidthLayout';
import LayoutCollectionView from '../LayoutCollectionView/LayoutCollectionView';
import LayoutLifestyleBanner from '../LayoutLifestyleBanner/LayoutLifestyleBanner';
import SlideShow from '../Carousel/SlideShow';
import ShopCard from '../ShopCard/ShopCard';
import OfferCard from '../Offer/OfferCard';
import GenericSectionContainer from './GenericSectionContainer';
import HeroBannerSection from './HeroBannerSection';
import LayoutAdContainer from '../LayoutAdContainer/LayoutAdContainer';
import { GoogleAdSlot } from '../GoogleAdSlot/GoogleAdSlot';
import {
  saveShop, removeShopById, saveOffer, removeOfferById
} from '../../../../lib/user';
import {
  SHOPS,
  OFFERS,
} from '../../../../lib/constants';
import LayoutSmallPromoBanner from '../LayoutSmallPromoBanner/LayoutSmallPromoBanner';
import { isNotExpired } from '../../../../lib/helpers';
import {
  getHeroBannersProps,
  getHeroSectionBannerLifestyleBannerProps,
} from '../../../../lib/helpers/getHeroBannerSectionProps.helpers';
import theme from '../../../theme';

const resolveUnionLayoutComponent = ({
  index,
  currLayout,
  locale,
  userData,
  pageStateModifiers,
  sectionTitle,
  adConfig,
  globalPageConfig,
  pageContext,
}) => {
  if (!currLayout) return null;

  const layoutKey = `${currLayout.__typename}-${currLayout.slug || currLayout.id}-${index}`;

  if (currLayout.contentType === 'layoutCollectionView') {
    if (currLayout.itemType === SHOPS) {
      const favShops = userData && userData.shops ? userData.shops : [];
      const favShopIds = favShops.map((shop) => shop.id);
      const { shops } = currLayout;

      return (
        <MaxWidthLayout key={layoutKey}>
          <LayoutCollectionView
            favItemIds={favShopIds}
            items={shops}
            Comp={ShopCard}
            itemType={SHOPS}
            tags={currLayout.tags}
            slug={currLayout.slug}
            viewType={currLayout.viewType}
            sectionTitle={currLayout.displayName}
            buttonText={currLayout.buttonText}
            buttonUrl={currLayout.buttonUrl}
            showDisplayName={currLayout.showDisplayName}
            saveItemHandler={saveShop}
            removeItemHandler={removeShopById}
            pageStateModifiers={pageStateModifiers}
            locale={locale}
            globalPageConfig={globalPageConfig}
            pageContext={pageContext} />
        </MaxWidthLayout>
      );
    } if (currLayout.itemType === OFFERS) {
      const favOffers = userData && userData.offers
        ? userData.offers : [];
      const favOfferIds = favOffers.map((offer) => offer.id);
      const { offers } = currLayout;
      return (
        <MaxWidthLayout key={layoutKey}>
          <LayoutCollectionView
            favItemIds={favOfferIds}
            items={offers}
            Comp={OfferCard}
            itemType={OFFERS}
            slug={currLayout.slug}
            tags={currLayout.tags}
            viewType={currLayout.viewType}
            sectionTitle={offers.length > 0 ? (sectionTitle || currLayout.displayName) : undefined}
            showDisplayName={currLayout.showDisplayName}
            buttonText={currLayout.buttonText}
            buttonUrl={currLayout.buttonUrl}
            saveItemHandler={saveOffer}
            removeItemHandler={removeOfferById}
            pageStateModifiers={pageStateModifiers}
            locale={locale}
            globalPageConfig={globalPageConfig}
            pageContext={pageContext} />
        </MaxWidthLayout>
      );
    }

    // *** TODO: (ericjim) - remaining types from the union type to be implemented ***
  } else if (currLayout.contentType === 'adContainer') {
    return (
      <MaxWidthLayout key={layoutKey}>
        <LayoutAdContainer
          pageStateModifiers={pageStateModifiers}
          adConfig={adConfig}
          locale={locale}
          {...currLayout}
          globalPageConfig={globalPageConfig} />
      </MaxWidthLayout>
    );
  } else if (currLayout.contentType === 'PROMO_CONTAINER') {
    return null;
  } else if (currLayout.contentType === 'layoutLifestyleBanner') {
    if (currLayout.startDate && currLayout.endDate && !isNotExpired(currLayout, 'startDate', 'endDate')) {
      return null;
    }
    return (
      <GenericSectionContainer key={layoutKey} top={1.5} bottom={1.5}>
        <LayoutLifestyleBanner locale={locale} {...currLayout} />
      </GenericSectionContainer>
    );
  } else if (currLayout.contentType === 'layoutSmallPromoBanner') {
    return (
      <MaxWidthLayout key={layoutKey}>
        <LayoutSmallPromoBanner
          locale={locale}
          {...currLayout} />
      </MaxWidthLayout>
    );
  } else if (currLayout.contentType === 'layoutHeroBanner') {
    const {
      textOverlay: bannerTitle,
      heroImageUrl,
      verticalHeroImageUrl,
      startDate,
      endDate,
      subtitle,
      backgroundColor,
      heroImageAltText,
      showDatesLabel = false,
      hexColorForTextOverlay,
    } = currLayout;

    if (startDate && endDate && !isNotExpired(currLayout, 'startDate', 'endDate')) {
      return null;
    }

    const {
      labelText,
      buttons,
    } = getHeroSectionBannerLifestyleBannerProps(currLayout, locale);

    return (
      <MaxWidthLayout
        key={layoutKey}
        backgroundColor={backgroundColor}
      >
        <HeroBannerSection
          heroImageUrl={heroImageUrl}
          portraitTabletHeroImageUrl={verticalHeroImageUrl}
          heroImageAltText={heroImageAltText}
          heading={bannerTitle}
          subheading={subtitle}
          labelText={showDatesLabel && labelText}
          buttons={buttons}
          backgroundColor={backgroundColor}
          textColor={hexColorForTextOverlay}
          classNames="is-standalone-layout"
        />
      </MaxWidthLayout>
    );
  } else if (currLayout.contentType === 'layoutCarouselContainer') {
    if (!currLayout.items) {
      return null;
    }

    const renderItems = getHeroBannersProps(currLayout.items, locale);

    if (!renderItems.length) {
      return null;
    }

    const outerBgColor = currLayout.backgroundColor || theme.c.bg['feature-1'];

    // TODO: Add logic to render differen item types, when added
    if (renderItems.length === 1) {
      const [renderItem] = renderItems;

      return (
        <MaxWidthLayout
          key={layoutKey}
          backgroundColor={renderItem.backgroundColor || theme.c.bg['feature-1']}
        >
          <HeroBannerSection
            {...renderItems[0]}
            classNames="is-standalone-layout"
            hasMultipleBg={outerBgColor !== renderItems[0].backgroundColor}
          />
        </MaxWidthLayout>
      );
    }

    return (
      <MaxWidthLayout
        key={layoutKey}
        backgroundColor={outerBgColor}
      >
        <SlideShow
          contorlsTheme={currLayout.controlsTheme}
          controlsTopMargin={currLayout.controlsTopMargin}
        >
          {renderItems.map((renderItem) => {
            return (
              <HeroBannerSection
                key={`${layoutKey}-${renderItem.slug}}`}
                {...renderItem}
                hasMultipleBg={outerBgColor !== renderItem.backgroundColor}
              />
            );
          })}
        </SlideShow>
      </MaxWidthLayout>
    );
  } else if (currLayout.__typename === 'googleAd') {
    if (!currLayout.active) {
      return null;
    }

    return (
      <GoogleAdSlot
        adId={currLayout.id}
        key={currLayout.id}
        verticalMargin={12}
      />
    );
  }

  return null;
};

const RenderLayoutViews = ({
  views = [],
  locale,
  userData,
  pageStateModifiers,
  sectionTitle,
  adConfig,
  globalPageConfig,
  pageContext,
}) => {
  if (!views || !views.length) {
    return null;
  }

  const layoutsToRender = views.map((item, index) => (
    resolveUnionLayoutComponent({
      index,
      currLayout: item,
      locale,
      userData,
      pageStateModifiers,
      sectionTitle,
      adConfig,
      globalPageConfig,
      pageContext,
    })
  ));

  return (
    <div>
      { layoutsToRender }
    </div>
  );
};

export default RenderLayoutViews;
